﻿$.fn.dxCtrlPlanitiHeure = function custom_dxCtrlPlanitiHeure(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlplanitiheure dx-ctrl");
        this.createInstance(new cdxCtrlPlanitiHeure(this, option));
    }
    return this;
}

window.cdxCtrlPlanitiHeure = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();

        option.lstHours.forEach(function (dat) {
            $("<div style='margin:5px 0;'/>").appendTo(container).dxCtrlButton({
                width: 150,
                text: dat.getHours() + ":" + ((dat.getMinutes() < 10) ? "0" : "") + dat.getMinutes(),
                onClick: function (e) {
                    if (!option.isInterne) option.onClickDate(dat)
                }
            })
        })
    }

    this.element = function () { return container; }

    mConstruit();
}